import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { computed, makeAutoObservable } from 'mobx';
import { useAppStateContext, AppState } from 'src/AppState/AppState';
import moment from 'moment';
import { EventsListTabNew } from 'src/components/CustomersBar/EventsTab/EventsListTab/EventsListTabNew';
import { EventsCollectionQueryType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import {
    EventsCollectionQueryCompetitionWithEventsType,
    EventsCollectionQueryModel,
} from 'src_common/common/websocket2/models/EventsCollectionQueryModel';

import RoutedTabs from 'src/components/Tabs/Routed';

interface PropsTypes {
    sport: string;
    userId: number;
}

const getSportStartTime = (sport: string): string => {
    const startOfDay = moment().startOf('day');

    switch (sport) {
        case 'cricket':
            return startOfDay.subtract(6, 'days').toISOString();
        case 'snooker':
            return startOfDay.subtract(2, 'days').toISOString();
        case 'tennis':
            return startOfDay.subtract(2, 'days').toISOString();
        case 'golf':
            return startOfDay.subtract(5, 'days').toISOString();
        case 'horseracing':
        case 'greyhoundracing':
            return moment().subtract(6, 'hours').isSame(moment(), 'day')
                ? startOfDay.toISOString()
                : startOfDay.subtract(6, 'hours').toISOString();
        default:
            return startOfDay.subtract(12, 'hours').toISOString();
    }
};

class State {
    public constructor(
        private readonly appState: AppState,
        private readonly props: PropsTypes
    ) {
        makeAutoObservable(this);
    }

    @computed private get query(): EventsCollectionQueryType {
        const starTime = getSportStartTime(this.props.sport);

        return {
            sport: [this.props.sport],
            state: 'open',
            'startTime[from]': starTime,
        };
    }

    @computed public get queryModel(): EventsCollectionQueryModel | null {
        return this.appState.websocketV2.getEventQuery(this.query);
    }

    @computed public get competitionItemViewWithEventIds(): Array<EventsCollectionQueryCompetitionWithEventsType> {
        return this.queryModel?.competitionsRaw ?? [];
    }
}

export const CompetitionsTabNew = observer('CompetitionsTabNew', (props: PropsTypes) => {
    const appState = useAppStateContext();
    const [state] = useState(() => new State(appState, props));
    const { competitionItemViewWithEventIds } = state;

    if (competitionItemViewWithEventIds.length === 0) {
        return (
            <div className='events-list'>
                <div className='alert'>No competitions available.</div>
            </div>
        );
    }

    return (
        <div className='events-list'>
            <RoutedTabs
                className='tabs__vertical'
                namespace='customers'
                parameter='competition'
            >
                {competitionItemViewWithEventIds.map((competition) => {
                    return (
                        <div
                            //@ts-expect-error
                            label={competition.name}
                            key={competition.id}
                        >
                            <EventsListTabNew
                                userId={props.userId}
                                competition={competition}
                            />
                        </div>
                    );
                })}
            </RoutedTabs>
        </div>
    );
});
